// Keeps the typed text while focused: a derived value (the coefficient) would erase "1." mid-typing.
import React, { useState } from "react"
import Input from "@react/shared/ui/Input"

const DECIMAL = /^\d*([.,]\d*)?$/

export const useDecimalDraft = ({ value, onChange, onFocus, onBlur }) => {
  const [draft, setDraft] = useState(null)
  const shown = draft ?? (value === null || value === undefined ? "" : String(value))

  return {
    type:      "text",
    inputMode: "decimal",
    value:     shown,
    onFocus:   event => { setDraft(shown); onFocus?.(event) },
    onBlur:    event => { setDraft(null); onBlur?.(event) },
    onChange:  event => {
      const raw = event.target.value.trim()
      if (!DECIMAL.test(raw)) return
      setDraft(raw)
      onChange(raw)
    },
  }
}

const DecimalInput = ({ value, onChange, onFocus, onBlur, ...props }) => (
  <Input {...props} {...useDecimalDraft({ value, onChange, onFocus, onBlur })} />
)

export default DecimalInput
